import { getRetinaSrcs } from '@helpers/image';
import SvgQuoteClose from '@img/icons/quote-close.svg';
import SvgQuoteOpen from '@img/icons/quote-open.svg';
import * as React from 'react';
import S from './ReviewCard.styles';
const ReviewCard = (props) => {
    const avatarSrcs = props.avatar
        ? getRetinaSrcs(props.avatar, props.isSingle ? 272 : 88, 1, {
            crop: 'thumb',
            gravity: 'face',
            zoom: 0.7,
        })
        : [];
    return (React.createElement(S.Container, { "data-alt": (props.index + 1) % 2 === 0, "data-variant": props.isSingle ? 'single' : 'carousel' },
        React.createElement(S.ShapeWrapper, null),
        React.createElement(S.QuoteIcon, { as: SvgQuoteOpen, "data-open": true }),
        React.createElement(S.QuoteIcon, { as: SvgQuoteClose, "data-close": true }),
        React.createElement(S.Inner, null,
            React.createElement(S.Content, null, props.content),
            React.createElement(S.Citation, null,
                React.createElement(S.AvatarWrapper, null, props.avatar ? (React.createElement(S.Avatar, { alt: props.avatar.altText, loading: "lazy", src: avatarSrcs[0].split(' ')[0], srcSet: avatarSrcs.join(',') })) : (React.createElement(S.AvatarPlaceholder, null, props.citation.substring(0, 1)))),
                React.createElement(S.NameWrapper, null,
                    React.createElement(S.Name, null, props.citation),
                    React.createElement(S.Title, null, props.citationTitle))))));
};
export default ReviewCard;
